import { NextSeo } from "next-seo";
import { useContext } from "react";

import CartComponent from "@components/Cart";
import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import Spacer from "@components/Spacer";
import Title from "@components/Title";
import UserContext from "@components/UserContext";

export default function CartPage() {
  const { cart } = useContext(UserContext);

  return (
    <Container>
      <NextSeo title="Cart | Bobcat Online Training" />
      <Spacer size="md" />
      <Title>Shopping Cart</Title>
      <CartComponent cart={cart} />
    </Container>
  );
}

CartPage.Layout = MainLayout;
